export function getFileExtensionIconClass(fileName) {
    const extension = fileName?.split('.')?.pop();

    const extensions = {
        "png": "png-image-icon",
        "jpg": "jpg-image-icon",
        "mov": "mov-image-icon",
        "pdf": "pdf-image-icon",
        "doc": "doc-image-icon"
    }

    return extensions[extension] ?? "general-image-icon";
}